import React from 'react';

const About: React.FC = () => {
    return (
      
        <div className="flex flex-col lg:flex-row w-full">
            
            {/* 1. Left Content Area (Text) - Now uses standard flex-grow and custom width on LG */}
            <div className="left-content flex-grow lg:w-[60%] bg-white text-gray-800 p-8 sm:p-12 lg:p-24 flex flex-col justify-center order-2 lg:order-1">
                
                {/* Updated Title */}
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                    Welcome to <br />
                    Bereilly Vermi Compost
                </h1>

                {/* Updated Text Block 1 */}
                <p className="text-base sm:text-lg leading-relaxed mb-4 max-w-xl">
                    Bereilly Vermi Compost is a registered company specializing in sustainable
                    agriculture solutions. We are dedicated to providing high-quality, 
                    nutrient-rich vermicompost to farmers and gardeners across the region.
                </p>

                {/* Updated Text Block 2 */}
                <p className="text-base sm:text-lg leading-relaxed mb-8 max-w-xl">
                    Our team has over 10 years of hands-on experience in organic waste 
                    management and advanced vermicomposting techniques. We transform organic 
                    waste into premium soil conditioner, ensuring a healthier and greener future for farming.
                </p>

                {/* More About Us Button */}
                <a 
                    href="/about" // Assuming you want this to link to the detailed about page
                    className="border-2 border-[#4f6a39] text-[#4f6a39] hover:bg-[#4f6a39] hover:text-white 
                               px-6 py-2 font-semibold rounded transition-colors duration-300 w-fit text-sm sm:text-base"
                >
                    Discover Our Products
                </a>
            </div>

            {/* 2. Right Content Area (Image and Badge) - Now uses standard flex-shrink and custom width on LG */}
            <div 
                // Mobile: h-80 (fixed height) or aspect-square. Desktop: min-h-screen
                className="right-content flex-shrink-0 lg:w-[40%] relative bg-cover bg-center h-80 lg:min-h-screen order-1 lg:order-2"
                style={{ 
                    backgroundImage: `url("https://5.imimg.com/data5/SELLER/Default/2024/5/417074475/VK/CB/RG/105762760/organic-vermicompost-fertilizer-500x500.png")` 
                }}
            >
                {/* Experience Badge - Adjusted for mobile centering and desktop positioning */}
                <div 
                    className="experience-badge absolute 
                               top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                               lg:top-10 lg:left-10 lg:translate-x-0 lg:translate-y-0 
                               bg-[#4f6a39] text-white p-6 shadow-lg flex flex-col items-center justify-center 
                               w-48 h-28 md:w-56 md:h-32"
                >
                    <p className="text-5xl md:text-6xl font-extrabold m-0 leading-none">
                        2+
                    </p>
                    <p className="text-base md:text-lg m-0 mt-1">
                        Years of Experience
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;